var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.76 7.73c-.01-.21-.19-.37-.4-.37h-3.07v-1.88c0-2.04-1.68-3.71-3.72-3.71h-1.15c-2.04 0-3.71 1.67-3.71 3.71v1.88h-3.07c-.21 0-.39.16-.4.37l-.74 12.38c-.06 1.15.85 2.12 2 2.12h13c1.15 0 2.06-.97 2-2.12l-.74-12.38Zm-10.75-2.25c0-1.33 1.08-2.41 2.41-2.41h1.15c1.33 0 2.42 1.08 2.42 2.41v1.88h-5.98v-1.88Zm-.66 5.47c-.69 0-1.25-.56-1.25-1.26 0-.46.24-.86.61-1.07v1.12c0 .22.18.4.4.4h.5c.22 0 .4-.18.4-.4v-1.11c.36.21.6.61.6 1.06 0 .7-.56 1.26-1.26 1.26Zm7.31 0c-.7 0-1.26-.56-1.26-1.26 0-.45.23-.84.59-1.06v1.16c.02.2.19.35.39.35h.51c.22 0 .4-.18.4-.4v-1.13c.37.22.62.62.62 1.08 0 .7-.56 1.26-1.25 1.26Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.31168a6b.svg";
export { ForwardRef as ReactComponent };